import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {LinkedMapsService} from "../linked-maps.service";
import {
  MapLink,
  MapPreview,
  ProgramMap,
  PublishedProgramSummary, PublishStatus
} from "../../../../../shared/programmapper-authoring.model";
import {Observable, ReplaySubject, Subject, Subscription, timer} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {MapsService} from "../../../maps.service";

@Component({
  selector: 'app-linked-maps-review-active-modal',
  templateUrl: './linked-maps-review-active-modal.component.html',
})
export class LinkedMapsReviewActiveModalComponent implements OnInit {

  program: PublishedProgramSummary;
  mapToUnlink: MapLink;
  sourceMap: ProgramMap;

  private currentSiteContentPreviewSource = new ReplaySubject<MapPreview>();
  currentSiteContentPreview$ : Observable<MapPreview> = this.currentSiteContentPreviewSource.asObservable();
  private previewPollingSub: Subscription;
  private unsubscribe$ = new Subject();

  constructor(protected router: Router,
              private route: ActivatedRoute,
              protected mapsService: MapsService,
              private linkedMapsService: LinkedMapsService) { }

  ngOnInit() {
    this.program = this.linkedMapsService.program;
    this.mapToUnlink = this.linkedMapsService.mapToUnlink;
    this.sourceMap = this.linkedMapsService.sourceMap;
  }

  hasCriticalDataIssues() {
    return false; // TODO: this may be a problem, need to handle in the response (one or more maps not previewable)
  }

  isPreviewPending(siteContentPreview: MapPreview) {
    return siteContentPreview.publishStatus === PublishStatus.PENDING;
  }

  isPreviewCompleted(siteContentPreview: MapPreview) {
    return siteContentPreview.publishStatus === PublishStatus.COMPLETED;
  }

  requestPreview() {
    this.linkedMapsService.postLinkedMapPreview(this.linkedMapsService.mapToUnlink.map.mapId, this.linkedMapsService.mapToUnlink.linkedMap.mapId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(mapPreview => {
        const tick$: Observable<number> = timer(0, 5000); // first check is at 0 seconds;

        this.previewPollingSub = tick$
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe(t => {

            const x = this.mapsService.getMapPreview(mapPreview.id)
              .pipe(takeUntil(this.unsubscribe$));

            x.subscribe(siteContentPreview => {
              if (siteContentPreview.publishStatus !== PublishStatus.PENDING) {
                this.previewPollingSub.unsubscribe();
              }
              this.currentSiteContentPreviewSource.next(siteContentPreview);
            });

            return x;
          });
      });
  }

  closeModal() {
    this.router.navigate([{ outlets: { popup: null } }], {relativeTo: this.route.parent, skipLocationChange: true}).then(
      () => {
        this.router.navigate([{ outlets: { subPopup: ['linked-maps'] } }],
          { relativeTo: this.route.parent, skipLocationChange: true });
      }
    );
  }

  openConfirmModal() {
    this.router.navigate([{ outlets: { popup: null } }], {relativeTo: this.route.parent, skipLocationChange: true}).then(
      () => {
        this.router.navigate([{ outlets: { popup: ['linked-maps-unlink'] } }],
          { relativeTo: this.route.parent, skipLocationChange: true });
      }
    );
  }
}
